const CrossCircle: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20.6047 12C20.6047 16.7522 16.7522 20.6047 12 20.6047C7.24778 20.6047 3.39535 16.7522 3.39535 12C3.39535 7.24778 7.24778 3.39535 12 3.39535C16.7522 3.39535 20.6047 7.24778 20.6047 12ZM15.284 8.71597C15.0116 8.44351 14.5698 8.44351 14.2974 8.71597L12 11.0133L9.70263 8.71597C9.43017 8.44351 8.98843 8.44351 8.71597 8.71597C8.44351 8.98843 8.44351 9.43017 8.71597 9.70263L11.0133 12L8.71597 14.2974C8.44351 14.5698 8.44351 15.0116 8.71597 15.284C8.98843 15.5565 9.43017 15.5565 9.70263 15.284L12 12.9867L14.2974 15.284C14.5698 15.5565 15.0116 15.5565 15.284 15.284C15.5565 15.0116 15.5565 14.5698 15.284 14.2974L12.9867 12L15.284 9.70263C15.5565 9.43017 15.5565 8.98843 15.284 8.71597Z"
      fill="currentColor"
    />
  </svg>
);

export default CrossCircle;
